<template>
  <div id="loading" v-if="isLoading" :class="transparent">
    <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
  </div>
</template>

<script>
  export default {
    computed: {
      isLoading () {
        return this.$store.getters['utils/isLoading'].status
      },
      transparent () {
        if (this.$store.getters['utils/isLoading'].transparent) {
          return 'transparent'
        } else {
          return ''
        }
      }
    }
  }
</script>

<style scoped>
  #loading { width: 100%; height: 100%; position: fixed; top: 0; left: 0; padding-left: 300px; z-index: 999999; background: rgba(255, 255, 255, 0.8); display: flex; align-items: center; justify-content: center; }
  .transparent { background: transparent !important; }

  @media (max-width: 959px) {
    #loading { padding-left: 0; }
  }
</style>



// WEBPACK FOOTER //
// Loading.vue?5ae29954